<h2 mat-dialog-title translate>{{ title }}</h2>
<mat-divider class="dialog__divider--top"></mat-divider>
<mat-dialog-content>
  <div class="content_dialog">
    <mat-icon [class]="icon" color="accent"></mat-icon>
    <div style="white-space: pre-line" id="response_message_dialog" *ngIf="!fName">{{ text }}</div>
    <p *ngIf="fName">
      ¿Seguro que quieres eliminar el fichero <strong>{{ fName }}</strong
      >?
    </p>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="center">
  <button
    *ngIf="hasButtonAccept"
    id="acceptButtonResponseDialog"
    mat-flat-button
    color="accent"
    class="btnMobile"
    (click)="accept()"
  >
    <span translate>dialog.response.accept</span>
  </button>
  <button
    *ngIf="buttonCancel"
    id="cancelButtonResponseDialog"
    mat-stroked-button
    color="accent"
    class="btnMobile"
    (click)="cancel()"
  >
    <span translate>button.cancel</span>
  </button>
  <button
    *ngIf="buttonClose"
    id="closeButtonResponseDialog"
    mat-flat-button
    color="accent"
    class="btnMobile"
    (click)="cancel()"
  >
    <span translate>button.close</span>
  </button>
</mat-dialog-actions>
